import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { obtenerObras, crearObra, actualizarObra } from "../redux/actions/index";

const AltaObra = () => {
  const dispatch = useDispatch();
  const obras = useSelector((state) => state.obras);

  const [nombre, setNombre] = useState("");
  const [obraSeleccionada, setObraSeleccionada] = useState(null);
  const [nombreEditado, setNombreEditado] = useState("");

  useEffect(() => {
    dispatch(obtenerObras());
  }, [dispatch]);

  const handleCrearObra = async () => {
    if (nombre) {
      try {
        await dispatch(crearObra({ nombre }));
        Swal.fire("Éxito", "Obra registrada correctamente", "success");
        setNombre("");
        dispatch(obtenerObras());
      } catch (error) {
        Swal.fire("Error", "No se pudo registrar la obra", "error");
      }
    } else {
      Swal.fire("Advertencia", "El nombre de la obra es obligatorio", "warning");
    }
  };

  const handleEditarObra = async () => {
    if (obraSeleccionada && nombreEditado) {
      try {
        await dispatch(actualizarObra(obraSeleccionada.id, { nombre: nombreEditado }));
        Swal.fire("Éxito", "Obra actualizada correctamente", "success");
        setObraSeleccionada(null);
        setNombreEditado("");
        dispatch(obtenerObras());
      } catch (error) {
        Swal.fire("Error", "No se pudo actualizar la obra", "error");
      }
    } else {
      Swal.fire("Advertencia", "El nombre de la obra es obligatorio", "warning");
    }
  };

  return (
    <div className="grid bg-backgroundClaro grid-cols-1 md:grid-cols-2 min-h-screen h-full w-full">
      {/* Formulario de registro */}
      <div className="bg-backgroundOscuro rounded-lg m-4 p-8">
        <h1 className="text-4xl font-bold text-white mb-4">Registrar Obra</h1>
        <div className="space-y-4">
          <div>
            <label className="block font-bold text-lg text-textoClaro">Nombre</label>
            <input
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
              placeholder="Nombre de la obra"
            />
          </div>
          <button
            onClick={handleCrearObra}
            className="w-full p-3 bg-green-800 text-textoClaro text-xl font-semibold rounded-md hover:bg-green-600 shadow-lg shadow-green-500/50 focus:ring-4 focus:ring-textoOscuro"
          >
            Registrar Obra
          </button>
        </div>
      </div>

      {/* Lista de obras */}
      <div className="bg-backgroundOscuro rounded-lg m-4 p-8">
        <h2 className="text-4xl font-bold text-textoClaro mb-4">Lista de Obras</h2>
        <ul className="flex flex-wrap gap-4">
          {obras.map((obra) => (
            <li
              key={obra.id}
              className="bg-backgroundClaro p-4 rounded-lg shadow-md w-full lg:w-[calc(50%-1rem)] cursor-pointer"
              onClick={() => {
                setObraSeleccionada(obra);
                setNombreEditado(obra.nombre);
              }}
            >
              <h3 className="text-textoOscuro font-bold">{obra.nombre}</h3>
            </li>
          ))}
        </ul>
      </div>

      {/* Modal de edición */}
      {obraSeleccionada && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-6 w-96">
            <h2 className="text-xl font-semibold mb-4">Editar Obra</h2>
            <div className="space-y-4">
              <div>
                <label className="block">Nombre</label>
                <input
                  type="text"
                  value={nombreEditado}
                  onChange={(e) => setNombreEditado(e.target.value)}
                  className="w-full p-2 rounded border-gray-300"
                />
              </div>
              <div className="flex justify-end gap-4">
                <button
                  onClick={() => setObraSeleccionada(null)}
                  className="p-2 bg-gray-400 text-white rounded-md hover:bg-gray-500"
                >
                  Cancelar
                </button>
                <button
                  onClick={handleEditarObra}
                  className="p-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AltaObra;